'use strict';
depositRegisterController.$inject = [
	'$scope',
	'$rootScope',
	'$q',
	'$interval',
	'dialogHelper',
	'reportHelper',
	'bankService',
	'accountStructureService',
	'USER_CLAIMS',
	'BUSY_MESSAGE',
];
angular.module('schoolLinqApp').controller('depositRegisterController', depositRegisterController);

function depositRegisterController(
	$scope,
	$rootScope,
	$q,
	$interval,
	dialogHelper,
	reportHelper,
	bankService,
	accountStructureService,
	USER_CLAIMS,
	BUSY_MESSAGE
) {
	var viewModel = getViewModel($rootScope.mode || 'fund');
	$scope.vm = viewModel;

	$scope.reportInterval = null;
	$scope.isReportFinished = false;

	$scope.loadingPromise = $q.all([$scope.vm.loadBanks($scope.vm), $scope.vm.loadAccountStructures($scope.vm)]);

	function getViewModel(moduleName) {
		var model = {
			module: moduleName,
			message: BUSY_MESSAGE.Loading,
			claimSections: USER_CLAIMS,
			accountStructure: [],
			banks: [],
			unifiedElementMap: null,
			unifiedAccountMask: null,
			filter: {
				bank: null,
				dateFrom: moment().toDate(),
				dateTo: moment().toDate(),
				depNumFrom: null,
				depNumTo: null,
				groupByAccount: false,
				accountFiltersGrid: null,
				accountFiltersType: null,
				reportParameters: [],
			},
			validationErrors: [],
			errors: null,
		};

		function validateReportParams(model) {
			model.validationErrors = [];
			let isValid = true;

			if (!model.filter.bank) {
				model.validationErrors.push('Please select a Bank.');
				isValid = false;
			}

			if (!model.filter.dateFrom) {
				model.validationErrors.push("Please select a 'From' date.");
				isValid = false;
			}

			if (!model.filter.dateTo) {
				model.validationErrors.push("Please select a 'To' date.");
				isValid = false;
			}

			if (isValid === true && moment(model.filter.dateFrom).startOf('day') > moment(model.filter.dateTo).startOf('day')) {
				model.validationErrors.push('Date Range is invalid!');
				isValid = false;
			}

			if (model.filter.depNumFrom || model.filter.depNumTo) {
				if (model.filter.depNumTo < model.filter.depNumFrom) {
					model.validationErrors.push('Deposit # Range is invalid!');
					isValid = false;
				}
			}

			if (model.unifiedElementMap) {
				for (let idx = 0; idx < model.filter.accountFiltersGrid.length; idx++) {
					let acctF = model.filter.accountFiltersGrid[idx];

					if (acctF.fromValue) {
						if (!acctF.toValue) {
							acctF.toValue = acctF.fromValue;
						}

						if (parseInt(acctF.fromValue) > parseInt(acctF.toValue)) {
							model.validationErrors.push("Element: '" + acctF.element + "' has an invalid range!");
							isValid = false;
						}
					}
				}
			} else {
				for (let idx = 0; idx < model.filter.accountFiltersType.length; idx++) {
					let acctF = model.filter.accountFiltersType[idx];

					if (!acctF.type) {
						model.validationErrors.push('Please select a valid Account Type!');
						isValid = false;
						break;
					} else {
						if (acctF.queries) {
							for (let qidx = 0; qidx < acctF.queries.length; qidx++) {
								let query = acctF.queries[qidx];

								if (query.AccountTypeId !== 0) {
									if (!query.ElementIndex) {
										model.validationErrors.push('Please select a valid Element for Account Range!');
										isValid = false;
									}
									if (!query.QueryOption) {
										model.validationErrors.push('Please select a range item for Account Range!');
										isValid = false;
									}
									if (!query.Value) {
										model.validationErrors.push('Please enter a value for Account Range!');
										isValid = false;
									}
									if (isValid === false) {
										break;
									}
								}
							}
						}
					}
				}
			}

			return isValid;
		}

		function openDepositRegister(model) {
			if (!validateReportParams(model)) {
				dialogHelper.openMessageBox('Deposit Register Report Error!', null, model.validationErrors);
				return false;
			}

			$scope.isReportFinished = false;
			model.message = BUSY_MESSAGE.GeneratingReport;
			$scope.loadingPromise = $scope.reportInterval = $interval(function () {
				if ($scope.isReportFinished) {
					$interval.cancel($scope.reportInterval);
					$scope.isReportFinished = false;
				}
			}, 1000);

			// Build Account Filter collection - Either Uniformed Mode or Non Uniformed Mode
			model.filter.reportParameters = [];
			if (model.unifiedElementMap) {
				angular.forEach(model.filter.accountFiltersGrid, function (acctF) {
					if (acctF.fromValue && acctF.fromValue.length > 0) {
						model.filter.reportParameters.push(acctF);
					}
				});
			} else {
				let typeObj = { Mask: '', ElementMap: '' };

				angular.forEach(model.filter.accountFiltersType, function (acctF) {
					typeObj = acctF.type;

					angular.forEach(acctF.queries, function (query) {
						if (query.AccountTypeId > 0 && query.ElementIndex && query.QueryOption && query.Value) {
							let paramModel = {
								element: '',
								maxLength: 0,
								maxValue: 0,
								fromValue: 0,
								toValue: 0,
								accountTypeId: 0,
								startIndex: 0,
								queryOption: '',
							};

							let elements = typeObj.ElementMap.split('.');
							let lengths = typeObj.Mask.split('.');
							let objElement = elements[parseInt(query.ElementIndex)];
							let objMask = lengths[parseInt(query.ElementIndex)];

							paramModel.accountTypeId = parseInt(query.AccountTypeId);
							paramModel.queryOption = query.QueryOption;
							paramModel.fromValue = parseInt(query.Value);
							paramModel.maxLength = objMask.length;
							paramModel.startIndex = 0;

							let indexCount = 1;
							for (let mIdx = 0; mIdx < parseInt(query.ElementIndex); mIdx++) {
								indexCount += lengths[mIdx].length;
							}

							paramModel.startIndex = indexCount;
							model.filter.reportParameters.push(paramModel);
						}
					});
				});
			}

			var report = {
				BankId: model.filter.bank.Id || 0,
				BankName: model.filter.bank.BankName,
				DateFrom: moment(model.filter.dateFrom).format('l'),
				DateTo: moment(model.filter.dateTo).format('l'),
				DepositNumFrom: parseInt(model.filter.depNumFrom) || 0,
				DepositNumTo: parseInt(model.filter.depNumTo) || 0,
				GroupByAccount: model.filter.groupByAccount,
				ElementRangeModelCol: model.filter.reportParameters,
			};

			reportHelper.postReport($scope, '/api/fundreports/depositregisterreport', report, 'DepositRegisterReport.pdf');
		}

		function exportExcel(model) {
			if (!validateReportParams(model)) {
				dialogHelper.openMessageBox('Deposit Register Error!', null, model.validationErrors);
				return false;
			}

			$scope.isReportFinished = false;
			model.message = BUSY_MESSAGE.GeneratingExcelFile;
			$scope.loadingPromise = $scope.reportInterval = $interval(function () {
				if ($scope.isReportFinished) {
					$interval.cancel($scope.reportInterval);
					$scope.isReportFinished = false;
				}
			}, 1000);

			// Build Account Filter collection - Either Uniformed Mode or Non Uniformed Mode
			model.filter.reportParameters = [];
			if (model.unifiedElementMap) {
				angular.forEach(model.filter.accountFiltersGrid, function (acctF) {
					if (acctF.fromValue && acctF.fromValue.length > 0) {
						model.filter.reportParameters.push(acctF);
					}
				});
			} else {
				let typeObj = { Mask: '', ElementMap: '' };

				angular.forEach(model.filter.accountFiltersType, function (acctF) {
					typeObj = acctF.type;

					angular.forEach(acctF.queries, function (query) {
						if (query.AccountTypeId > 0 && query.ElementIndex && query.QueryOption && query.Value) {
							let paramModel = {
								element: '',
								maxLength: 0,
								maxValue: 0,
								fromValue: 0,
								toValue: 0,
								accountTypeId: 0,
								startIndex: 0,
								queryOption: '',
							};

							let elements = typeObj.ElementMap.split('.');
							let lengths = typeObj.Mask.split('.');
							let objElement = elements[parseInt(query.ElementIndex)];
							let objMask = lengths[parseInt(query.ElementIndex)];

							paramModel.accountTypeId = parseInt(query.AccountTypeId);
							paramModel.queryOption = query.QueryOption;
							paramModel.fromValue = parseInt(query.Value);
							paramModel.maxLength = objMask.length;
							paramModel.startIndex = 0;

							let indexCount = 1;
							for (let mIdx = 0; mIdx < parseInt(query.ElementIndex); mIdx++) {
								indexCount += lengths[mIdx].length;
							}

							paramModel.startIndex = indexCount;
							model.filter.reportParameters.push(paramModel);
						}
					});
				});
			}

			var report = {
				BankId: model.filter.bank.Id || 0,
				BankName: model.filter.bank.BankName,
				DateFrom: moment(model.filter.dateFrom).format('l'),
				DateTo: moment(model.filter.dateTo).format('l'),
				DepositNumFrom: parseInt(model.filter.depNumFrom) || 0,
				DepositNumTo: parseInt(model.filter.depNumTo) || 0,
				GroupByAccount: model.filter.groupByAccount,
				ElementRangeModelCol: model.filter.reportParameters,
			};

			reportHelper.postExcel($scope, '/api/fundreports/depositregisterexcel', report, 'DepositRegister.xlsx');
		}

		function loadBanks(model) {
			return bankService.getBanks(false, true).then(_.partial(finishLoadingBanks, model));

			function finishLoadingBanks(model, response) {
				model.banks = response.data.banks;

				let bObj = {
					Id: 0,
					BankName: 'All',
					ShortName: 'All',
					DisplayName: 'All',
				};

				model.banks.unshift(bObj);
				model.filter.bank = model.banks[0];
				return angular.noop;
			}
		}

		function loadAccountStructures(model) {
			return accountStructureService.getStructure().then(_.partial(finishLoadingAccountStructures, model));

			function finishLoadingAccountStructures(model, response) {
				model.unifiedElementMap = response.data.accountStructure.UnifiedElementMap;
				model.unifiedAccountMask = response.data.accountStructure.UnifiedAccountMask;
				model.accountStructure = response.data.accountStructure;
				return angular.noop;
			}
		}

		function fixDateRangeToDate(model) {
			if (!model.filter.dateTo || moment(model.filter.dateFrom).startOf('day') > moment(model.filter.dateTo).startOf('day')) {
				model.filter.dateTo = model.filter.dateFrom;
			}
		}

		function fixElementToValue(model, index) {
			var acctF = model.accountFilters[index];
			if (acctF) {
				if (!acctF.toValue || parseInt(acctF.fromValue) > parseInt(acctF.toValue)) {
					acctF.toValue = acctF.maxValue;
				}
			}
		}

		function fixDepositNumTo(model) {
			if (model.filter.depNumFrom) {
				if (!model.filter.depNumTo || model.filter.depNumFrom > model.filter.depNumTo) {
					model.filter.depNumTo = model.filter.depNumFrom;
				}
			}
		}

		function fixDepositNumFrom(model) {
			if (model.filter.depNumTo) {
				if (!model.filter.depNumFrom) {
					model.filter.depNumFrom = 0;
				}
			}
		}

		function selectGroupBy(model, groupBy) {
			if (groupBy === 'A') {
				model.filter.groupByAccount = true;
			} else {
				model.filter.groupByAccount = false;
			}
		}

		return angular.extend(model, {
			openDepositRegister: _.partial(openDepositRegister, model),
			exportExcel: _.partial(exportExcel, model),
			loadBanks: _.partial(loadBanks, model),
			loadAccountStructures: _.partial(loadAccountStructures, model),
			fixDepositNumTo: _.partial(fixDepositNumTo, model),
			fixDepositNumFrom: _.partial(fixDepositNumFrom, model),
			selectGroupBy: _.partial(selectGroupBy, model),
			fixDateRangeToDate: _.partial(fixDateRangeToDate, model),
			fixElementToValue: _.partial(fixElementToValue, model),
		});
	}
}
